/* eslint-disable */
/**
 * The path of the `ReportsPage` to be consumed by a `<Router />`
 * @export
 */
export const REPORTS_PAGE_PATH = `/reports`;

/**
 * Create a `href` that will resolve to `ReportsPage`
 * @export
 * @returns {string} The `REPORTS_PAGE_PATH`
 */
export const createReportsPageLink = () => REPORTS_PAGE_PATH;

/**
 * Determine if the current page is the `ReportsPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `ReportsPage`
 */
export const isReportsPage = (match) => match.path === REPORTS_PAGE_PATH;
